<template>
    <div @click="changeState" class="order"><svg-icon :icon="icon" :svg-class="svgClass"/></div>
</template>

<script>
    export default {
        name: "SortColumn",
        props: {
            columnName: {
                type: String,
                default: null
            },
            svgClass: {
                type: [String, Array, Object],
                required: false,
                default: 'svg-class'
            },
            source: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                state: null
            }
        },
        methods: {
            changeState() {
                if (this.state === null) this.state = 'asc';
                else if (this.state === 'asc') this.state = 'desc';
                else this.state = null;
                this.$emit('changeOrder', {columnName: this.columnName, order: this.state});
            }
        },
        computed: {
            icon() {
                let icon = 'sort';
                if (this.state === 'asc') icon = 'sort-amount-up';
                else if (this.state === 'desc') icon = 'sort-amount-down';

                return icon
            }
        },
        beforeMount() {
            if (this.source && this.source[this.columnName] !== undefined)
                this.state = this.source[this.columnName];
        }
    }
</script>

<style scoped lang="scss">
    .order {
        cursor: pointer;
        user-select: none;
    }

    .svg-class {
        color: #fff;
        width: 1em;
        height: 1em;
    }
</style>
